import _ from 'lodash';
import React from 'react';
import {
  FilledInput,
  FormControl,
  FormHelperText,
  Input,
  InputLabel,
  OutlinedInput,
  Select,
  MenuItem
} from "@mui/material";

import { withFormsy } from 'formsy-react';
import { pick } from 'lodash';

function SelectFormsy(props) {
  const importedProps = pick(props, [
    'autoWidth',
    'children',
    'classes',
    'displayEmpty',
    'input',
    'inputProps',
    'MenuProps',
    'multiple',
    'native',
    'onClose',
    'onOpen',
    'open',
    'renderValue',
    'SelectDisplayProps',
    'variant',
    'color',
    'required',
  ]);

  // An error message is returned only if the component is invalid
  const { options, errorMessage, description, value, optionAlias } = props;

  function input() {
    switch (importedProps.variant) {
    case 'outlined':
      return <OutlinedInput label={props.label} id={props.name} />;
    case 'filled':
      return <FilledInput id={props.name} />;
    default:
      return <Input id={props.name} />;
    }
  }

  function changeValue(event) {
    const optionValue = event.target.value;
    const selectedOption = options.find(o => o.alias === optionValue);
    props.setValue(selectedOption);
    if (props.onChange) {
      props.onChange(event);
    }
  }

  const helperText = errorMessage || description;
  const optionValue = (Array.isArray(value) ? value[0] : value)?.alias || optionAlias;
  return (
    <FormControl
      error={Boolean((!props.isPristine && props.showRequired) || errorMessage)}
      className={props.className}
      variant={importedProps.variant}
      disabled={props.disabled}
    >
      {props.label && <InputLabel id={`${props.name}-label`}>{props.label}</InputLabel>}
      <Select
        {...importedProps}
        labelId={`${props.name}-label`}
        value={optionValue || ''}
        onChange={changeValue}
        input={input()}
      >
        {(options || []).map(option => (
          <MenuItem value={option.alias} key={option.alias}>{option.label}</MenuItem>
        ))}
      </Select>
      {Boolean(helperText) && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
}

export default React.memo(withFormsy(SelectFormsy));
